import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { faCheck, faCopy } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StyledButton = styled.button`
	&,
	&:hover {
		display: inline;
		background-color: transparent;
		color: black;
		padding: 0;
		border: none;
	}
`;

export default function TextCopyButton({ text, title, fontSize, color }: { readonly text: string; title?: string; fontSize?: string; color?: string }) {
	const [copied, setCopied] = useState(false);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

	useEffect(() => () => clearTimeout(timeoutRef.current), []);

	return (
		<StyledButton
			title={copied ? "Kopiert!" : (title ?? "Kopier verdi")}
			onClick={() => {
				navigator.clipboard.writeText(text);
				setCopied(true);
				clearTimeout(timeoutRef.current);
				timeoutRef.current = setTimeout(() => setCopied(false), 1500);
			}}
			style={{ cursor: "pointer" }}
		>
			<FontAwesomeIcon color={copied ? "var(--varsel-groenn)" : color} icon={copied ? faCheck : faCopy} fontSize={fontSize} />
		</StyledButton>
	);
}
